import { SortIcon } from 'client/components/common/icons';
import React from 'react';
import { SortOption } from 'client/generated';

type Props = {
  sortOptionId: string | null | undefined;
  sortOptions: SortOption[];
  onClick: () => void;
};

const defaultName = '並び順';

export const SortButton: React.FC<Props> = ({ sortOptionId, sortOptions, onClick }) => {
  const sortName: string = sortOptions?.find((option) => option.id === sortOptionId)?.name || defaultName;
  return (
    <div className={'flex my-5 ml-6'} onClick={onClick}>
      <SortIcon />
      <p className={`text-xs my-auto ml-2 ${sortName !== defaultName && 'text-light-black font-bold'} `}>{sortName}</p>
    </div>
  );
};
